// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "async/appvue." + {"624": "fb50b3cf","66": "907f5cef","668": "a5d23841","714": "4d1bc482","739": "3f11ff2a",}[chunkId] + ".js"
}